import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DateConstants } from '../core/persian-date';
import { SharedService } from './shared.service';

@Injectable({
  providedIn: 'root'
})
export class NpsService {

  constructor(private http: HttpClient) { }

  ask(guest: boolean) {
    if (localStorage.getItem('nps'))
      try { return Promise.resolve(JSON.parse(localStorage.getItem('nps'))); } catch { }
    if (guest) return Promise.resolve(null);
    return this.http.get<any>(environment.app.apiUrl + `nps/ask`).toPromise();
  }
  answer(nps: any) {
    return new Promise(async (resolve, reject) => {
      try {
        var result = await this.http.post<any>(environment.app.apiUrl + `nps/answer`, nps, { context: SharedService.NO_LOADING_BAR }).toPromise();
        localStorage.setItem('nps', JSON.stringify(result));
        resolve(result);
      } catch (e) { reject(e); }
    });
  }

  getForUser(id: string) {
    return this.http.get<any[]>(environment.app.apiUrl + `nps/user/get/${id}`).toPromise();
  }

  registerAnswer(nps: any) {
    return this.http.post<any[]>(environment.app.apiUrl + `nps/user/register`, nps).toPromise();
  }

  getForAdminByItemId(itemId: string) {
    return this.http.get<any[]>(environment.app.apiUrl + `nps/admin/get/item/${itemId}`).toPromise();
  }
  registerAnswerByAdmin(nps: any) {
    return this.http.post<any[]>(environment.app.apiUrl + `nps/admin/register`, nps).toPromise();
  }
  report(criteria: any): any {
    return this.http.post<any[]>(environment.app.apiUrl + `nps/admin/report`, criteria).toPromise();
  }
  setIsStarred(npsId: string, isStarred: boolean): any {
    return this.http.post(environment.app.apiUrl + `nps/admin/star`, { npsId, isStarred }).toPromise();
  }


}
